import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Directive, HostListener, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { defineCustomElements } from '@bh-digitalsolutions/ui-toolkit/loader';

/* eslint-disable */
/* tslint:disable */
const _c0 = ["*"];
const proxyInputs = (Cmp, inputs) => {
  const Prototype = Cmp.prototype;
  inputs.forEach(item => {
    Object.defineProperty(Prototype, item, {
      get() {
        return this.el[item];
      },
      set(val) {
        this.z.runOutsideAngular(() => this.el[item] = val);
      },
      /**
       * In the event that proxyInputs is called
       * multiple times re-defining these inputs
       * will cause an error to be thrown. As a result
       * we set configurable: true to indicate these
       * properties can be changed.
       */
      configurable: true
    });
  });
};
const proxyMethods = (Cmp, methods) => {
  const Prototype = Cmp.prototype;
  methods.forEach(methodName => {
    Prototype[methodName] = function () {
      const args = arguments;
      return this.z.runOutsideAngular(() => this.el[methodName].apply(this.el, args));
    };
  });
};
const proxyOutputs = (instance, el, events) => {
  events.forEach(eventName => instance[eventName] = new EventEmitter());
};
const defineCustomElement = (tagName, customElement) => {
  if (customElement !== undefined && typeof customElements !== 'undefined' && !customElements.get(tagName)) {
    customElements.define(tagName, customElement);
  }
};
// tslint:disable-next-line: only-arrow-functions
function ProxyCmp(opts) {
  const decorator = function (cls) {
    const {
      defineCustomElementFn,
      inputs,
      methods
    } = opts;
    if (defineCustomElementFn !== undefined) {
      defineCustomElementFn();
    }
    if (inputs) {
      proxyInputs(cls, inputs);
    }
    if (methods) {
      proxyMethods(cls, methods);
    }
    return cls;
  };
  return decorator;
}
let BhA = /*#__PURE__*/(() => {
  let BhA = class BhA {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhA_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhA)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhA,
      selectors: [["bh-a"]],
      inputs: {
        externalLink: "externalLink",
        font: "font",
        href: "href",
        isDisabled: "isDisabled",
        isFooter: "isFooter",
        leftIcon: "leftIcon",
        noUnderline: "noUnderline",
        rightIcon: "rightIcon",
        tabularwidth: "tabularwidth",
        target: "target",
        text: "text",
        textLimit: "textLimit",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhA_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhA = __decorate([ProxyCmp({
    inputs: ['externalLink', 'font', 'href', 'isDisabled', 'isFooter', 'leftIcon', 'noUnderline', 'rightIcon', 'tabularwidth', 'target', 'text', 'textLimit', 'type']
  })], BhA);
  return BhA;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhAccordion = /*#__PURE__*/(() => {
  let BhAccordion = class BhAccordion {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose']);
    }
    static ɵfac = function BhAccordion_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhAccordion)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhAccordion,
      selectors: [["bh-accordion"]],
      inputs: {
        header: "header",
        iconOrientation: "iconOrientation",
        isOpen: "isOpen",
        size: "size",
        subtext: "subtext"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhAccordion_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhAccordion = __decorate([ProxyCmp({
    inputs: ['header', 'iconOrientation', 'isOpen', 'size', 'subtext']
  })], BhAccordion);
  return BhAccordion;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhActionBar = /*#__PURE__*/(() => {
  let BhActionBar = class BhActionBar {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ctaClick', 'bhEventCtaClick']);
    }
    static ɵfac = function BhActionBar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhActionBar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhActionBar,
      selectors: [["bh-action-bar"]],
      inputs: {
        buttonDropdownFooterAction: "buttonDropdownFooterAction",
        footerActions: "footerActions"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhActionBar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhActionBar = __decorate([ProxyCmp({
    inputs: ['buttonDropdownFooterAction', 'footerActions']
  })], BhActionBar);
  return BhActionBar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhActionMenu = /*#__PURE__*/(() => {
  let BhActionMenu = class BhActionMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['opened', 'bhEventOpen', 'bhEventClose', 'bhEventSelected', 'bhEventChange', 'bhEventCtaClick']);
    }
    static ɵfac = function BhActionMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhActionMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhActionMenu,
      selectors: [["bh-action-menu"]],
      inputs: {
        additionalMenuItems: "additionalMenuItems",
        disableTooltip: "disableTooltip",
        enableMicroInteraction: "enableMicroInteraction",
        flipHorizontal: "flipHorizontal",
        flipOffset: "flipOffset",
        iconOverride: "iconOverride",
        inlineAnchorId: "inlineAnchorId",
        isEllipsis: "isEllipsis",
        isInline: "isInline",
        isMultiSelect: "isMultiSelect",
        isOpen: "isOpen",
        isSearchable: "isSearchable",
        isSelectAll: "isSelectAll",
        isSmall: "isSmall",
        isUnselectable: "isUnselectable",
        menuItems: "menuItems",
        menuWidth: "menuWidth",
        placeholder: "placeholder",
        selectedValue: "selectedValue",
        tooltipIsInline: "tooltipIsInline",
        tooltipLeftPadding: "tooltipLeftPadding",
        tooltipPlacement: "tooltipPlacement"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhActionMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhActionMenu = __decorate([ProxyCmp({
    inputs: ['additionalMenuItems', 'disableTooltip', 'enableMicroInteraction', 'flipHorizontal', 'flipOffset', 'iconOverride', 'inlineAnchorId', 'isEllipsis', 'isInline', 'isMultiSelect', 'isOpen', 'isSearchable', 'isSelectAll', 'isSmall', 'isUnselectable', 'menuItems', 'menuWidth', 'placeholder', 'selectedValue', 'tooltipIsInline', 'tooltipLeftPadding', 'tooltipPlacement']
  })], BhActionMenu);
  return BhActionMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhAlert = /*#__PURE__*/(() => {
  let BhAlert = class BhAlert {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhAlert_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhAlert)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhAlert,
      selectors: [["bh-alert"]],
      inputs: {
        alerts: "alerts",
        closeOnCtaClick: "closeOnCtaClick",
        dismissAfter: "dismissAfter",
        timeout: "timeout",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhAlert_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhAlert = __decorate([ProxyCmp({
    inputs: ['alerts', 'closeOnCtaClick', 'dismissAfter', 'timeout', 'type']
  })], BhAlert);
  return BhAlert;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhAlertItem = /*#__PURE__*/(() => {
  let BhAlertItem = class BhAlertItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['removeAlertItem', 'bhEventClose']);
    }
    static ɵfac = function BhAlertItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhAlertItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhAlertItem,
      selectors: [["bh-alert-item"]],
      inputs: {
        alertkey: "alertkey",
        dismissAfter: "dismissAfter",
        dismissible: "dismissible",
        index: "index",
        isOpened: "isOpened",
        message: "message",
        status: "status",
        timeout: "timeout",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhAlertItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhAlertItem = __decorate([ProxyCmp({
    inputs: ['alertkey', 'dismissAfter', 'dismissible', 'index', 'isOpened', 'message', 'status', 'timeout', 'type']
  })], BhAlertItem);
  return BhAlertItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhAppShell = /*#__PURE__*/(() => {
  let BhAppShell = class BhAppShell {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['isSettingsMenuOpenUpdate', 'bhEventSelected', 'bhEventChange', 'bhEventScroll']);
    }
    static ɵfac = function BhAppShell_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhAppShell)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhAppShell,
      selectors: [["bh-app-shell"]],
      inputs: {
        applogo: "applogo",
        appname: "appname",
        enableAppShellMenuMicroInteraction: "enableAppShellMenuMicroInteraction",
        headerLimit: "headerLimit",
        iconLinks: "iconLinks",
        isMenuOpen: "isMenuOpen",
        mobileViewLabel: "mobileViewLabel",
        navigation: "navigation",
        navigationSelected: "navigationSelected",
        settings: "settings",
        settingsSelected: "settingsSelected",
        type: "type",
        useremail: "useremail",
        userfirstname: "userfirstname",
        userimage: "userimage",
        userlastname: "userlastname"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhAppShell_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhAppShell = __decorate([ProxyCmp({
    inputs: ['applogo', 'appname', 'enableAppShellMenuMicroInteraction', 'headerLimit', 'iconLinks', 'isMenuOpen', 'mobileViewLabel', 'navigation', 'navigationSelected', 'settings', 'settingsSelected', 'type', 'useremail', 'userfirstname', 'userimage', 'userlastname']
  })], BhAppShell);
  return BhAppShell;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhAppShellMenu = /*#__PURE__*/(() => {
  let BhAppShellMenu = class BhAppShellMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventSelected']);
    }
    static ɵfac = function BhAppShellMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhAppShellMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhAppShellMenu,
      selectors: [["bh-app-shell-menu"]],
      inputs: {
        enableMicroInteraction: "enableMicroInteraction",
        isMobileMenuOpen: "isMobileMenuOpen",
        isSettingsMenuOpen: "isSettingsMenuOpen",
        isSideMenuOpen: "isSideMenuOpen",
        mobileViewLabel: "mobileViewLabel",
        navigation: "navigation",
        navigationSelected: "navigationSelected",
        settings: "settings",
        settingsSelected: "settingsSelected",
        type: "type",
        userInfo: "userInfo"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhAppShellMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhAppShellMenu = __decorate([ProxyCmp({
    inputs: ['enableMicroInteraction', 'isMobileMenuOpen', 'isSettingsMenuOpen', 'isSideMenuOpen', 'mobileViewLabel', 'navigation', 'navigationSelected', 'settings', 'settingsSelected', 'type', 'userInfo']
  })], BhAppShellMenu);
  return BhAppShellMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhAvatar = /*#__PURE__*/(() => {
  let BhAvatar = class BhAvatar {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhAvatar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhAvatar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhAvatar,
      selectors: [["bh-avatar"]],
      inputs: {
        firstname: "firstname",
        image: "image",
        isActive: "isActive",
        isRing: "isRing",
        lastname: "lastname",
        size: "size",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhAvatar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhAvatar = __decorate([ProxyCmp({
    inputs: ['firstname', 'image', 'isActive', 'isRing', 'lastname', 'size', 'type']
  })], BhAvatar);
  return BhAvatar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhAvatarGroup = /*#__PURE__*/(() => {
  let BhAvatarGroup = class BhAvatarGroup {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhAvatarGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhAvatarGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhAvatarGroup,
      selectors: [["bh-avatar-group"]],
      inputs: {
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhAvatarGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhAvatarGroup = __decorate([ProxyCmp({
    inputs: ['type']
  })], BhAvatarGroup);
  return BhAvatarGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhBadge = /*#__PURE__*/(() => {
  let BhBadge = class BhBadge {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhBadge_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhBadge)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhBadge,
      selectors: [["bh-badge"]],
      inputs: {
        color: "color",
        icon: "icon",
        isFluid: "isFluid",
        label: "label",
        offset: "offset",
        position: "position",
        theme: "theme",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhBadge_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhBadge = __decorate([ProxyCmp({
    inputs: ['color', 'icon', 'isFluid', 'label', 'offset', 'position', 'theme', 'type']
  })], BhBadge);
  return BhBadge;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhBarChart = /*#__PURE__*/(() => {
  let BhBarChart = class BhBarChart {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhBarChart_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhBarChart)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhBarChart,
      selectors: [["bh-bar-chart"]],
      inputs: {
        chartOptionOverride: "chartOptionOverride",
        data: "data",
        height: "height",
        option: "option",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhBarChart_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhBarChart = __decorate([ProxyCmp({
    inputs: ['chartOptionOverride', 'data', 'height', 'option', 'theme']
  })], BhBarChart);
  return BhBarChart;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhBreadcrumbs = /*#__PURE__*/(() => {
  let BhBreadcrumbs = class BhBreadcrumbs {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['opened', 'itemSelectedUpdate', 'bhEventOpen', 'bhEventClose', 'bhEventChange', 'bhEventSelected']);
    }
    static ɵfac = function BhBreadcrumbs_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhBreadcrumbs)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhBreadcrumbs,
      selectors: [["bh-breadcrumbs"]],
      inputs: {
        inlineAnchorId: "inlineAnchorId",
        isBorder: "isBorder",
        isInline: "isInline",
        items: "items",
        menuWidth: "menuWidth",
        selectedItem: "selectedItem"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhBreadcrumbs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhBreadcrumbs = __decorate([ProxyCmp({
    inputs: ['inlineAnchorId', 'isBorder', 'isInline', 'items', 'menuWidth', 'selectedItem']
  })], BhBreadcrumbs);
  return BhBreadcrumbs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhButton = /*#__PURE__*/(() => {
  let BhButton = class BhButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhButton,
      selectors: [["bh-button"]],
      inputs: {
        disablePointerEvent: "disablePointerEvent",
        disableTooltip: "disableTooltip",
        isDisabled: "isDisabled",
        isFluid: "isFluid",
        isLoading: "isLoading",
        isSmall: "isSmall",
        label: "label",
        leftIcon: "leftIcon",
        rightIcon: "rightIcon",
        tooltipMessage: "tooltipMessage",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhButton = __decorate([ProxyCmp({
    inputs: ['disablePointerEvent', 'disableTooltip', 'isDisabled', 'isFluid', 'isLoading', 'isSmall', 'label', 'leftIcon', 'rightIcon', 'tooltipMessage', 'type']
  })], BhButton);
  return BhButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhButtonDropdown = /*#__PURE__*/(() => {
  let BhButtonDropdown = class BhButtonDropdown {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['opened', 'bhEventOpen', 'bhEventClose', 'bhEventSelected', 'bhEventChange', 'bhEventCtaClick']);
    }
    static ɵfac = function BhButtonDropdown_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhButtonDropdown)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhButtonDropdown,
      selectors: [["bh-button-dropdown"]],
      inputs: {
        additionalMenuItems: "additionalMenuItems",
        enableMicroInteraction: "enableMicroInteraction",
        flipOffset: "flipOffset",
        flipVertical: "flipVertical",
        iconOverride: "iconOverride",
        isDisabled: "isDisabled",
        isEllipsis: "isEllipsis",
        isFluid: "isFluid",
        isInline: "isInline",
        isLoading: "isLoading",
        isMultiSelect: "isMultiSelect",
        isOpen: "isOpen",
        isSearchable: "isSearchable",
        isSelectAll: "isSelectAll",
        isSmall: "isSmall",
        isUnselectable: "isUnselectable",
        label: "label",
        leftIcon: "leftIcon",
        menuItems: "menuItems",
        menuWidth: "menuWidth",
        placeholder: "placeholder",
        rightIcon: "rightIcon",
        tooltipMessage: "tooltipMessage",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhButtonDropdown_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhButtonDropdown = __decorate([ProxyCmp({
    inputs: ['additionalMenuItems', 'enableMicroInteraction', 'flipOffset', 'flipVertical', 'iconOverride', 'isDisabled', 'isEllipsis', 'isFluid', 'isInline', 'isLoading', 'isMultiSelect', 'isOpen', 'isSearchable', 'isSelectAll', 'isSmall', 'isUnselectable', 'label', 'leftIcon', 'menuItems', 'menuWidth', 'placeholder', 'rightIcon', 'tooltipMessage', 'type']
  })], BhButtonDropdown);
  return BhButtonDropdown;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhButtonGroup = /*#__PURE__*/(() => {
  let BhButtonGroup = class BhButtonGroup {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhButtonGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhButtonGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhButtonGroup,
      selectors: [["bh-button-group"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhButtonGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhButtonGroup = __decorate([ProxyCmp({})], BhButtonGroup);
  return BhButtonGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhButtonTabs = /*#__PURE__*/(() => {
  let BhButtonTabs = class BhButtonTabs {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['activeTabUpdate', 'bhEventOpen', 'bhEventClose', 'bhEventSelected']);
    }
    static ɵfac = function BhButtonTabs_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhButtonTabs)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhButtonTabs,
      selectors: [["bh-button-tabs"]],
      inputs: {
        activeKey: "activeKey",
        ellipsisTextLimit: "ellipsisTextLimit",
        isSmall: "isSmall",
        items: "items",
        menuWidth: "menuWidth",
        tooltipMessage: "tooltipMessage"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhButtonTabs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhButtonTabs = __decorate([ProxyCmp({
    inputs: ['activeKey', 'ellipsisTextLimit', 'isSmall', 'items', 'menuWidth', 'tooltipMessage']
  })], BhButtonTabs);
  return BhButtonTabs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhCard = /*#__PURE__*/(() => {
  let BhCard = class BhCard {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ctaClick', 'bhEventCtaClick', 'bhEventOpen', 'bhEventClose']);
    }
    static ɵfac = function BhCard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhCard)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhCard,
      selectors: [["bh-card"]],
      inputs: {
        actionMenu: "actionMenu",
        border: "border",
        expandableOpen: "expandableOpen",
        footerActions: "footerActions",
        headerActions: "headerActions",
        heading: "heading",
        icon: "icon",
        isExpandable: "isExpandable",
        isFocusable: "isFocusable",
        stopBubble: "stopBubble",
        subtext: "subtext",
        tooltipText: "tooltipText"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhCard_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhCard = __decorate([ProxyCmp({
    inputs: ['actionMenu', 'border', 'expandableOpen', 'footerActions', 'headerActions', 'heading', 'icon', 'isExpandable', 'isFocusable', 'stopBubble', 'subtext', 'tooltipText']
  })], BhCard);
  return BhCard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhCheckbox = /*#__PURE__*/(() => {
  let BhCheckbox = class BhCheckbox {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhCheckbox_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhCheckbox)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhCheckbox,
      selectors: [["bh-checkbox"]],
      inputs: {
        isChecked: "isChecked",
        isDisabled: "isDisabled",
        isError: "isError",
        isIndeterminate: "isIndeterminate",
        isUnfocusable: "isUnfocusable",
        label: "label",
        message: "message",
        name: "name",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhCheckbox_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhCheckbox = __decorate([ProxyCmp({
    inputs: ['isChecked', 'isDisabled', 'isError', 'isIndeterminate', 'isUnfocusable', 'label', 'message', 'name', 'value']
  })], BhCheckbox);
  return BhCheckbox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhChip = /*#__PURE__*/(() => {
  let BhChip = class BhChip {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventClose', 'bhEventChange']);
    }
    static ɵfac = function BhChip_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhChip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhChip,
      selectors: [["bh-chip"]],
      inputs: {
        color: "color",
        dismissible: "dismissible",
        icon: "icon",
        isDisabled: "isDisabled",
        label: "label",
        link: "link",
        plain: "plain",
        preSelect: "preSelect",
        selectedColor: "selectedColor",
        selectedTheme: "selectedTheme",
        size: "size",
        theme: "theme",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhChip_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhChip = __decorate([ProxyCmp({
    inputs: ['color', 'dismissible', 'icon', 'isDisabled', 'label', 'link', 'plain', 'preSelect', 'selectedColor', 'selectedTheme', 'size', 'theme', 'type']
  })], BhChip);
  return BhChip;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhChipGroup = /*#__PURE__*/(() => {
  let BhChipGroup = class BhChipGroup {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhChipGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhChipGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhChipGroup,
      selectors: [["bh-chip-group"]],
      inputs: {
        isOverflow: "isOverflow"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhChipGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhChipGroup = __decorate([ProxyCmp({
    inputs: ['isOverflow']
  })], BhChipGroup);
  return BhChipGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhContent = /*#__PURE__*/(() => {
  let BhContent = class BhContent {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhContent,
      selectors: [["bh-content"]],
      inputs: {
        backgroundColor: "backgroundColor",
        contentPush: "contentPush",
        cookiesHREF: "cookiesHREF",
        cookiesText: "cookiesText",
        isNoPadding: "isNoPadding",
        isSideMenuOpen: "isSideMenuOpen",
        privacyHREF: "privacyHREF",
        privacyText: "privacyText",
        progress: "progress",
        progressBarMode: "progressBarMode",
        showLogo: "showLogo",
        showProgressBar: "showProgressBar",
        termsHREF: "termsHREF",
        termsText: "termsText",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhContent = __decorate([ProxyCmp({
    inputs: ['backgroundColor', 'contentPush', 'cookiesHREF', 'cookiesText', 'isNoPadding', 'isSideMenuOpen', 'privacyHREF', 'privacyText', 'progress', 'progressBarMode', 'showLogo', 'showProgressBar', 'termsHREF', 'termsText', 'theme']
  })], BhContent);
  return BhContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhDataTable = /*#__PURE__*/(() => {
  let BhDataTable = class BhDataTable {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['getTableDataset', 'customHtmlElementClick', 'sortUpdate', 'bhEventCtaClick', 'bhEventChange']);
    }
    static ɵfac = function BhDataTable_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhDataTable)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhDataTable,
      selectors: [["bh-data-table"]],
      inputs: {
        content: "content",
        option: "option",
        sortState: "sortState"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhDataTable_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhDataTable = __decorate([ProxyCmp({
    inputs: ['content', 'option', 'sortState']
  })], BhDataTable);
  return BhDataTable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhDatePicker = /*#__PURE__*/(() => {
  let BhDatePicker = class BhDatePicker {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange', 'bhEventOpen']);
    }
    static ɵfac = function BhDatePicker_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhDatePicker)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhDatePicker,
      selectors: [["bh-date-picker"]],
      inputs: {
        clearButton: "clearButton",
        customDisableDate: "customDisableDate",
        dateFormat: "dateFormat",
        disableHelper: "disableHelper",
        disableUserInput: "disableUserInput",
        disabled: "disabled",
        errorMessage: "errorMessage",
        id: "id",
        isInfo: "isInfo",
        isInvalid: "isInvalid",
        isReadOnly: "isReadOnly",
        isRequired: "isRequired",
        isSmall: "isSmall",
        label: "label",
        maxValue: "maxValue",
        minValue: "minValue",
        placeholder: "placeholder",
        reset: "reset",
        value: "value",
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhDatePicker_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhDatePicker = __decorate([ProxyCmp({
    inputs: ['clearButton', 'customDisableDate', 'dateFormat', 'disableHelper', 'disableUserInput', 'disabled', 'errorMessage', 'id', 'isInfo', 'isInvalid', 'isReadOnly', 'isRequired', 'isSmall', 'label', 'maxValue', 'minValue', 'placeholder', 'reset', 'value', 'width']
  })], BhDatePicker);
  return BhDatePicker;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhDateRangePicker = /*#__PURE__*/(() => {
  let BhDateRangePicker = class BhDateRangePicker {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhDateRangePicker_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhDateRangePicker)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhDateRangePicker,
      selectors: [["bh-date-range-picker"]],
      inputs: {
        dateFormat: "dateFormat",
        disableHelper: "disableHelper",
        disableUserInput: "disableUserInput",
        endDateLabel: "endDateLabel",
        errorMessage: "errorMessage",
        id: "id",
        isInvalid: "isInvalid",
        isReadOnly: "isReadOnly",
        isRequired: "isRequired",
        isReset: "isReset",
        reset: "reset",
        startDateLabel: "startDateLabel",
        value: "value",
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhDateRangePicker_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhDateRangePicker = __decorate([ProxyCmp({
    inputs: ['dateFormat', 'disableHelper', 'disableUserInput', 'endDateLabel', 'errorMessage', 'id', 'isInvalid', 'isReadOnly', 'isRequired', 'isReset', 'reset', 'startDateLabel', 'value', 'width']
  })], BhDateRangePicker);
  return BhDateRangePicker;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhDateTimePicker = /*#__PURE__*/(() => {
  let BhDateTimePicker = class BhDateTimePicker {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhDateTimePicker_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhDateTimePicker)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhDateTimePicker,
      selectors: [["bh-date-time-picker"]],
      inputs: {
        dateErrorMessage: "dateErrorMessage",
        dateLabel: "dateLabel",
        disableHelper: "disableHelper",
        id: "id",
        isInvalid: "isInvalid",
        isReadOnly: "isReadOnly",
        isRequired: "isRequired",
        maxValue: "maxValue",
        minValue: "minValue",
        reset: "reset",
        timeErrorMessage: "timeErrorMessage",
        timeFormat: "timeFormat",
        timeLabel: "timeLabel",
        value: "value",
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhDateTimePicker_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhDateTimePicker = __decorate([ProxyCmp({
    inputs: ['dateErrorMessage', 'dateLabel', 'disableHelper', 'id', 'isInvalid', 'isReadOnly', 'isRequired', 'maxValue', 'minValue', 'reset', 'timeErrorMessage', 'timeFormat', 'timeLabel', 'value', 'width']
  })], BhDateTimePicker);
  return BhDateTimePicker;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhDialog = /*#__PURE__*/(() => {
  let BhDialog = class BhDialog {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose', 'bhEventCtaClick', 'ctaClick']);
    }
    static ɵfac = function BhDialog_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhDialog)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhDialog,
      selectors: [["bh-dialog"]],
      inputs: {
        ctas: "ctas",
        enableMicroInteraction: "enableMicroInteraction",
        header: "header",
        illustration: "illustration",
        isDismissible: "isDismissible",
        isHTMLTemplate: "isHTMLTemplate",
        isOpen: "isOpen",
        message: "message"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhDialog_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhDialog = __decorate([ProxyCmp({
    inputs: ['ctas', 'enableMicroInteraction', 'header', 'illustration', 'isDismissible', 'isHTMLTemplate', 'isOpen', 'message']
  })], BhDialog);
  return BhDialog;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhDivider = /*#__PURE__*/(() => {
  let BhDivider = class BhDivider {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhDivider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhDivider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhDivider,
      selectors: [["bh-divider"]],
      inputs: {
        marginBottom: "marginBottom",
        marginLeft: "marginLeft",
        marginRight: "marginRight",
        marginTop: "marginTop",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhDivider_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhDivider = __decorate([ProxyCmp({
    inputs: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop', 'type']
  })], BhDivider);
  return BhDivider;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhDonutChart = /*#__PURE__*/(() => {
  let BhDonutChart = class BhDonutChart {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhDonutChart_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhDonutChart)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhDonutChart,
      selectors: [["bh-donut-chart"]],
      inputs: {
        chartOptionOverride: "chartOptionOverride",
        data: "data",
        height: "height",
        label: "label",
        legendLayout: "legendLayout",
        option: "option",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhDonutChart_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhDonutChart = __decorate([ProxyCmp({
    inputs: ['chartOptionOverride', 'data', 'height', 'label', 'legendLayout', 'option', 'theme']
  })], BhDonutChart);
  return BhDonutChart;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhDropdown = /*#__PURE__*/(() => {
  let BhDropdown = class BhDropdown {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose', 'bhEventCtaClick', 'bhEventSelected', 'bhEventChange', 'selected', 'opened']);
    }
    static ɵfac = function BhDropdown_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhDropdown)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhDropdown,
      selectors: [["bh-dropdown"]],
      inputs: {
        enableMicroInteraction: "enableMicroInteraction",
        flipOffset: "flipOffset",
        fromtabularlist: "fromtabularlist",
        inlineAnchorId: "inlineAnchorId",
        isDisabled: "isDisabled",
        isEllipsis: "isEllipsis",
        isError: "isError",
        isFluid: "isFluid",
        isInline: "isInline",
        isItemPaddingRight: "isItemPaddingRight",
        isMultiSelect: "isMultiSelect",
        isOpen: "isOpen",
        isRequired: "isRequired",
        isSearchable: "isSearchable",
        isSelectAll: "isSelectAll",
        isSmall: "isSmall",
        isUnselectable: "isUnselectable",
        keyboardFocused: "keyboardFocused",
        label: "label",
        menuItems: "menuItems",
        menuWidth: "menuWidth",
        message: "message",
        placeholder: "placeholder",
        searchMode: "searchMode",
        selectedValue: "selectedValue",
        showAllLabel: "showAllLabel",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhDropdown_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhDropdown = __decorate([ProxyCmp({
    inputs: ['enableMicroInteraction', 'flipOffset', 'fromtabularlist', 'inlineAnchorId', 'isDisabled', 'isEllipsis', 'isError', 'isFluid', 'isInline', 'isItemPaddingRight', 'isMultiSelect', 'isOpen', 'isRequired', 'isSearchable', 'isSelectAll', 'isSmall', 'isUnselectable', 'keyboardFocused', 'label', 'menuItems', 'menuWidth', 'message', 'placeholder', 'searchMode', 'selectedValue', 'showAllLabel', 'value']
  })], BhDropdown);
  return BhDropdown;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhError = /*#__PURE__*/(() => {
  let BhError = class BhError {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventCtaClick', 'ctaClick']);
    }
    static ɵfac = function BhError_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhError)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhError,
      selectors: [["bh-error"]],
      inputs: {
        ctas: "ctas",
        description: "description",
        errorNumber: "errorNumber",
        source: "source",
        title: "title"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhError_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhError = __decorate([ProxyCmp({
    inputs: ['ctas', 'description', 'errorNumber', 'source', 'title']
  })], BhError);
  return BhError;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhFooter = /*#__PURE__*/(() => {
  let BhFooter = class BhFooter {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhFooter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhFooter)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhFooter,
      selectors: [["bh-footer"]],
      inputs: {
        cookiesHREF: "cookiesHREF",
        cookiesText: "cookiesText",
        logo: "logo",
        marginTop: "marginTop",
        privacyHREF: "privacyHREF",
        privacyText: "privacyText",
        showLogo: "showLogo",
        termsHREF: "termsHREF",
        termsText: "termsText",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhFooter_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhFooter = __decorate([ProxyCmp({
    inputs: ['cookiesHREF', 'cookiesText', 'logo', 'marginTop', 'privacyHREF', 'privacyText', 'showLogo', 'termsHREF', 'termsText', 'theme']
  })], BhFooter);
  return BhFooter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhFormMessage = /*#__PURE__*/(() => {
  let BhFormMessage = class BhFormMessage {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhFormMessage_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhFormMessage)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhFormMessage,
      selectors: [["bh-form-message"]],
      inputs: {
        isDisabled: "isDisabled",
        isError: "isError",
        message: "message"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhFormMessage_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhFormMessage = __decorate([ProxyCmp({
    inputs: ['isDisabled', 'isError', 'message']
  })], BhFormMessage);
  return BhFormMessage;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhHeader = /*#__PURE__*/(() => {
  let BhHeader = class BhHeader {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventCtaClick']);
    }
    static ɵfac = function BhHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhHeader,
      selectors: [["bh-header"]],
      inputs: {
        appname: "appname",
        closeSettingsMenu: "closeSettingsMenu",
        headerLimit: "headerLimit",
        iconLinks: "iconLinks",
        logo: "logo",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhHeader = __decorate([ProxyCmp({
    inputs: ['appname', 'closeSettingsMenu', 'headerLimit', 'iconLinks', 'logo', 'type']
  })], BhHeader);
  return BhHeader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhIcon = /*#__PURE__*/(() => {
  let BhIcon = class BhIcon {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventClick', 'bhEventOnMouseHover']);
    }
    static ɵfac = function BhIcon_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhIcon)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhIcon,
      selectors: [["bh-icon"]],
      inputs: {
        color: "color",
        href: "href",
        icon: "icon",
        size: "size",
        target: "target"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhIcon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhIcon = __decorate([ProxyCmp({
    inputs: ['color', 'href', 'icon', 'size', 'target']
  })], BhIcon);
  return BhIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhIllustration = /*#__PURE__*/(() => {
  let BhIllustration = class BhIllustration {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhIllustration_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhIllustration)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhIllustration,
      selectors: [["bh-illustration"]],
      inputs: {
        description: "description",
        source: "source",
        title: "title"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhIllustration_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhIllustration = __decorate([ProxyCmp({
    inputs: ['description', 'source', 'title']
  })], BhIllustration);
  return BhIllustration;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhIncrementer = /*#__PURE__*/(() => {
  let BhIncrementer = class BhIncrementer {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['focus', 'blur', 'bhEventInput', 'bhEventChange']);
    }
    static ɵfac = function BhIncrementer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhIncrementer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhIncrementer,
      selectors: [["bh-incrementer"]],
      inputs: {
        incrementFactor: "incrementFactor",
        isDisabled: "isDisabled",
        isError: "isError",
        isFluid: "isFluid",
        isReadOnly: "isReadOnly",
        label: "label",
        maxValue: "maxValue",
        message: "message",
        minValue: "minValue",
        placeholderNumber: "placeholderNumber",
        unit: "unit",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhIncrementer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhIncrementer = __decorate([ProxyCmp({
    inputs: ['incrementFactor', 'isDisabled', 'isError', 'isFluid', 'isReadOnly', 'label', 'maxValue', 'message', 'minValue', 'placeholderNumber', 'unit', 'value']
  })], BhIncrementer);
  return BhIncrementer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhInlineDropdown = /*#__PURE__*/(() => {
  let BhInlineDropdown = class BhInlineDropdown {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose', 'bhEventChange', 'bhEventSelected', 'selected', 'opened']);
    }
    static ɵfac = function BhInlineDropdown_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhInlineDropdown)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhInlineDropdown,
      selectors: [["bh-inline-dropdown"]],
      inputs: {
        enableMicroInteraction: "enableMicroInteraction",
        flipOffset: "flipOffset",
        inlineAnchorId: "inlineAnchorId",
        isEllipsis: "isEllipsis",
        isInline: "isInline",
        isOpen: "isOpen",
        isSearchable: "isSearchable",
        isSmall: "isSmall",
        menuItems: "menuItems",
        menuWidth: "menuWidth",
        selectedValue: "selectedValue",
        typography: "typography",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhInlineDropdown_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhInlineDropdown = __decorate([ProxyCmp({
    inputs: ['enableMicroInteraction', 'flipOffset', 'inlineAnchorId', 'isEllipsis', 'isInline', 'isOpen', 'isSearchable', 'isSmall', 'menuItems', 'menuWidth', 'selectedValue', 'typography', 'value']
  })], BhInlineDropdown);
  return BhInlineDropdown;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhKpi = /*#__PURE__*/(() => {
  let BhKpi = class BhKpi {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhKpi_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhKpi)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhKpi,
      selectors: [["bh-kpi"]],
      inputs: {
        icon: "icon",
        kpiTitle: "kpiTitle",
        stats: "stats",
        sub: "sub",
        sup: "sup",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhKpi_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhKpi = __decorate([ProxyCmp({
    inputs: ['icon', 'kpiTitle', 'stats', 'sub', 'sup', 'value']
  })], BhKpi);
  return BhKpi;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhLineChart = /*#__PURE__*/(() => {
  let BhLineChart = class BhLineChart {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhLineChart_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhLineChart)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhLineChart,
      selectors: [["bh-line-chart"]],
      inputs: {
        chartOptionOverride: "chartOptionOverride",
        data: "data",
        height: "height",
        option: "option",
        theme: "theme",
        yaxisallowstring: "yaxisallowstring"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhLineChart_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhLineChart = __decorate([ProxyCmp({
    inputs: ['chartOptionOverride', 'data', 'height', 'option', 'theme', 'yaxisallowstring']
  })], BhLineChart);
  return BhLineChart;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhList = /*#__PURE__*/(() => {
  let BhList = class BhList {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhList,
      selectors: [["bh-list"]],
      inputs: {
        padding: "padding"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhList_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhList = __decorate([ProxyCmp({
    inputs: ['padding']
  })], BhList);
  return BhList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhMenu = /*#__PURE__*/(() => {
  let BhMenu = class BhMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['multiselectChange', 'ctaClick', 'bhEventChange', 'bhEventSelected', 'bhEventInput', 'bhEventCtaClick', 'unselect', 'close']);
    }
    static ɵfac = function BhMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhMenu,
      selectors: [["bh-menu"]],
      inputs: {
        clearSearchText: "clearSearchText",
        isDropDownMenu: "isDropDownMenu",
        isEllipsis: "isEllipsis",
        isFocused: "isFocused",
        isItemPaddingRight: "isItemPaddingRight",
        isMultiSelect: "isMultiSelect",
        isSearchable: "isSearchable",
        isSelectAll: "isSelectAll",
        isTypeAhead: "isTypeAhead",
        isUnselectable: "isUnselectable",
        keyboardFocused: "keyboardFocused",
        menuHeight: "menuHeight",
        menuItems: "menuItems",
        menuWidth: "menuWidth",
        placeholder: "placeholder",
        query: "query",
        searchMode: "searchMode",
        selected: "selected",
        tooltipIsInline: "tooltipIsInline",
        tooltipLeftPadding: "tooltipLeftPadding",
        tooltipPlacement: "tooltipPlacement"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhMenu = __decorate([ProxyCmp({
    inputs: ['clearSearchText', 'isDropDownMenu', 'isEllipsis', 'isFocused', 'isItemPaddingRight', 'isMultiSelect', 'isSearchable', 'isSelectAll', 'isTypeAhead', 'isUnselectable', 'keyboardFocused', 'menuHeight', 'menuItems', 'menuWidth', 'placeholder', 'query', 'searchMode', 'selected', 'tooltipIsInline', 'tooltipLeftPadding', 'tooltipPlacement']
  })], BhMenu);
  return BhMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhMenuItem = /*#__PURE__*/(() => {
  let BhMenuItem = class BhMenuItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhMenuItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhMenuItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhMenuItem,
      selectors: [["bh-menu-item"]],
      inputs: {
        chevron: "chevron",
        icon: "icon",
        id: "id",
        isFocusable: "isFocusable",
        isHovered: "isHovered",
        isKeyboardFocused: "isKeyboardFocused",
        isSelected: "isSelected",
        isSubmenuBackSelected: "isSubmenuBackSelected",
        label: "label",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhMenuItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhMenuItem = __decorate([ProxyCmp({
    inputs: ['chevron', 'icon', 'id', 'isFocusable', 'isHovered', 'isKeyboardFocused', 'isSelected', 'isSubmenuBackSelected', 'label', 'type']
  })], BhMenuItem);
  return BhMenuItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhMobileMenu = /*#__PURE__*/(() => {
  let BhMobileMenu = class BhMobileMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhMobileMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhMobileMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhMobileMenu,
      selectors: [["bh-mobile-menu"]],
      inputs: {
        isOpen: "isOpen",
        mobileViewLabel: "mobileViewLabel",
        navigation: "navigation",
        settings: "settings",
        useremail: "useremail",
        userfirstname: "userfirstname",
        userimage: "userimage",
        userlastname: "userlastname"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhMobileMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhMobileMenu = __decorate([ProxyCmp({
    inputs: ['isOpen', 'mobileViewLabel', 'navigation', 'settings', 'useremail', 'userfirstname', 'userimage', 'userlastname']
  })], BhMobileMenu);
  return BhMobileMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhModal = /*#__PURE__*/(() => {
  let BhModal = class BhModal {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose', 'bhEventCtaClick', 'ctaClick']);
    }
    static ɵfac = function BhModal_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhModal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhModal,
      selectors: [["bh-modal"]],
      inputs: {
        ctas: "ctas",
        enableMicroInteraction: "enableMicroInteraction",
        header: "header",
        isDismissible: "isDismissible",
        isOpen: "isOpen",
        outsideModalClick: "outsideModalClick",
        subheader: "subheader",
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhModal_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhModal = __decorate([ProxyCmp({
    inputs: ['ctas', 'enableMicroInteraction', 'header', 'isDismissible', 'isOpen', 'outsideModalClick', 'subheader', 'width']
  })], BhModal);
  return BhModal;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhNavMenu = /*#__PURE__*/(() => {
  let BhNavMenu = class BhNavMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['navSubMenuOpened', 'navSubMenuClosed']);
    }
    static ɵfac = function BhNavMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhNavMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhNavMenu,
      selectors: [["bh-nav-menu"]],
      inputs: {
        navigation: "navigation",
        type: "type",
        withAppShellMenu: "withAppShellMenu"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhNavMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhNavMenu = __decorate([ProxyCmp({
    inputs: ['navigation', 'type', 'withAppShellMenu']
  })], BhNavMenu);
  return BhNavMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhPagination = /*#__PURE__*/(() => {
  let BhPagination = class BhPagination {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['pageNumberChange', 'itemCountChange', 'dropdownOpened', 'bhEventChange', 'bhEventSelected']);
    }
    static ɵfac = function BhPagination_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhPagination)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhPagination,
      selectors: [["bh-pagination"]],
      inputs: {
        enableMicroInteraction: "enableMicroInteraction",
        itemCount: "itemCount",
        itemCountOptions: "itemCountOptions",
        numOfPagesToExpose: "numOfPagesToExpose",
        pagePreSelect: "pagePreSelect",
        refresh: "refresh",
        totalItemCount: "totalItemCount"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhPagination_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhPagination = __decorate([ProxyCmp({
    inputs: ['enableMicroInteraction', 'itemCount', 'itemCountOptions', 'numOfPagesToExpose', 'pagePreSelect', 'refresh', 'totalItemCount']
  })], BhPagination);
  return BhPagination;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhPanel = /*#__PURE__*/(() => {
  let BhPanel = class BhPanel {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose']);
    }
    static ɵfac = function BhPanel_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhPanel)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhPanel,
      selectors: [["bh-panel"]],
      inputs: {
        enableMicroInteraction: "enableMicroInteraction",
        header: "header",
        isOpen: "isOpen",
        isPadded: "isPadded",
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhPanel_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhPanel = __decorate([ProxyCmp({
    inputs: ['enableMicroInteraction', 'header', 'isOpen', 'isPadded', 'width']
  })], BhPanel);
  return BhPanel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhProgressBar = /*#__PURE__*/(() => {
  let BhProgressBar = class BhProgressBar {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['progressComplete']);
    }
    static ɵfac = function BhProgressBar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhProgressBar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhProgressBar,
      selectors: [["bh-progress-bar"]],
      inputs: {
        automaticTimeout: "automaticTimeout",
        mode: "mode",
        progress: "progress",
        size: "size"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhProgressBar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhProgressBar = __decorate([ProxyCmp({
    inputs: ['automaticTimeout', 'mode', 'progress', 'size']
  })], BhProgressBar);
  return BhProgressBar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhRadioButton = /*#__PURE__*/(() => {
  let BhRadioButton = class BhRadioButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhRadioButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhRadioButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhRadioButton,
      selectors: [["bh-radio-button"]],
      inputs: {
        isChecked: "isChecked",
        isDisabled: "isDisabled",
        isError: "isError",
        label: "label",
        name: "name",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhRadioButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhRadioButton = __decorate([ProxyCmp({
    inputs: ['isChecked', 'isDisabled', 'isError', 'label', 'name', 'value']
  })], BhRadioButton);
  return BhRadioButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhScatterChart = /*#__PURE__*/(() => {
  let BhScatterChart = class BhScatterChart {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhScatterChart_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhScatterChart)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhScatterChart,
      selectors: [["bh-scatter-chart"]],
      inputs: {
        chartOptionOverride: "chartOptionOverride",
        data: "data",
        height: "height",
        option: "option",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhScatterChart_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhScatterChart = __decorate([ProxyCmp({
    inputs: ['chartOptionOverride', 'data', 'height', 'option', 'theme']
  })], BhScatterChart);
  return BhScatterChart;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhSearch = /*#__PURE__*/(() => {
  let BhSearch = class BhSearch {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['query', 'results', 'ctaClick', 'bhEventCtaClick']);
    }
    static ɵfac = function BhSearch_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhSearch)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhSearch,
      selectors: [["bh-search"]],
      inputs: {
        data: "data",
        disableFuzzySearch: "disableFuzzySearch",
        disablePointerEvent: "disablePointerEvent",
        isButtonSearch: "isButtonSearch",
        isDisabled: "isDisabled",
        isError: "isError",
        isFluid: "isFluid",
        isRounded: "isRounded",
        isSmall: "isSmall",
        maxLength: "maxLength",
        onBlur: "onBlur",
        onFocus: "onFocus",
        placeholder: "placeholder",
        search: "search",
        searchParams: "searchParams",
        shouldTrim: "shouldTrim",
        type: "type",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhSearch_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhSearch = __decorate([ProxyCmp({
    inputs: ['data', 'disableFuzzySearch', 'disablePointerEvent', 'isButtonSearch', 'isDisabled', 'isError', 'isFluid', 'isRounded', 'isSmall', 'maxLength', 'onBlur', 'onFocus', 'placeholder', 'search', 'searchParams', 'shouldTrim', 'type', 'value']
  })], BhSearch);
  return BhSearch;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhSelectionGroup = /*#__PURE__*/(() => {
  let BhSelectionGroup = class BhSelectionGroup {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhSelectionGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhSelectionGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhSelectionGroup,
      selectors: [["bh-selection-group"]],
      inputs: {
        isDisabled: "isDisabled",
        isError: "isError",
        isGrid: "isGrid",
        layout: "layout",
        message: "message"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhSelectionGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhSelectionGroup = __decorate([ProxyCmp({
    inputs: ['isDisabled', 'isError', 'isGrid', 'layout', 'message']
  })], BhSelectionGroup);
  return BhSelectionGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhSettingsMenu = /*#__PURE__*/(() => {
  let BhSettingsMenu = class BhSettingsMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['settingsSubmenuOpened', 'settingsSubmenuClosed']);
    }
    static ɵfac = function BhSettingsMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhSettingsMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhSettingsMenu,
      selectors: [["bh-settings-menu"]],
      inputs: {
        isFocusable: "isFocusable",
        isMobile: "isMobile",
        isOpen: "isOpen",
        isSubmenuBackSelected: "isSubmenuBackSelected",
        settings: "settings",
        useremail: "useremail",
        userfirstname: "userfirstname",
        userimage: "userimage",
        userlastname: "userlastname"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhSettingsMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhSettingsMenu = __decorate([ProxyCmp({
    inputs: ['isFocusable', 'isMobile', 'isOpen', 'isSubmenuBackSelected', 'settings', 'useremail', 'userfirstname', 'userimage', 'userlastname']
  })], BhSettingsMenu);
  return BhSettingsMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhSlider = /*#__PURE__*/(() => {
  let BhSlider = class BhSlider {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventInput', 'bhEventChange']);
    }
    static ɵfac = function BhSlider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhSlider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhSlider,
      selectors: [["bh-slider"]],
      inputs: {
        isDisabled: "isDisabled",
        maxLabel: "maxLabel",
        maxValue: "maxValue",
        minLabel: "minLabel",
        minValue: "minValue",
        prefixText: "prefixText",
        size: "size",
        sliderLabel: "sliderLabel",
        suffixText: "suffixText",
        textOnly: "textOnly",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhSlider_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhSlider = __decorate([ProxyCmp({
    inputs: ['isDisabled', 'maxLabel', 'maxValue', 'minLabel', 'minValue', 'prefixText', 'size', 'sliderLabel', 'suffixText', 'textOnly', 'value']
  })], BhSlider);
  return BhSlider;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhSpinner = /*#__PURE__*/(() => {
  let BhSpinner = class BhSpinner {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhSpinner_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhSpinner)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhSpinner,
      selectors: [["bh-spinner"]],
      inputs: {
        offset: "offset",
        position: "position",
        size: "size"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhSpinner_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhSpinner = __decorate([ProxyCmp({
    inputs: ['offset', 'position', 'size']
  })], BhSpinner);
  return BhSpinner;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhStatusIndicator = /*#__PURE__*/(() => {
  let BhStatusIndicator = class BhStatusIndicator {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhStatusIndicator_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhStatusIndicator)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhStatusIndicator,
      selectors: [["bh-status-indicator"]],
      inputs: {
        color: "color",
        isFluid: "isFluid",
        offset: "offset",
        position: "position",
        size: "size",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhStatusIndicator_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhStatusIndicator = __decorate([ProxyCmp({
    inputs: ['color', 'isFluid', 'offset', 'position', 'size', 'theme']
  })], BhStatusIndicator);
  return BhStatusIndicator;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhStepper = /*#__PURE__*/(() => {
  let BhStepper = class BhStepper {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange', 'stepClick', 'complete']);
    }
    static ɵfac = function BhStepper_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhStepper)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhStepper,
      selectors: [["bh-stepper"]],
      inputs: {
        current: "current",
        layout: "layout",
        steps: "steps"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhStepper_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhStepper = __decorate([ProxyCmp({
    inputs: ['current', 'layout', 'steps']
  })], BhStepper);
  return BhStepper;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhSystemAlertItem = /*#__PURE__*/(() => {
  let BhSystemAlertItem = class BhSystemAlertItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['removeAlertItem', 'bhEventOpen', 'bhEventClose', 'bhEventCtaClick', 'ctaClick']);
    }
    static ɵfac = function BhSystemAlertItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhSystemAlertItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhSystemAlertItem,
      selectors: [["bh-system-alert-item"]],
      inputs: {
        alertkey: "alertkey",
        closeOnCtaClick: "closeOnCtaClick",
        ctas: "ctas",
        header: "header",
        index: "index",
        isOpen: "isOpen",
        message: "message",
        opacity: "opacity",
        status: "status",
        timestamp: "timestamp"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhSystemAlertItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhSystemAlertItem = __decorate([ProxyCmp({
    inputs: ['alertkey', 'closeOnCtaClick', 'ctas', 'header', 'index', 'isOpen', 'message', 'opacity', 'status', 'timestamp']
  })], BhSystemAlertItem);
  return BhSystemAlertItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTabs = /*#__PURE__*/(() => {
  let BhTabs = class BhTabs {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['activeTabUpdate', 'bhEventOpen', 'bhEventClose', 'bhEventSelected']);
    }
    static ɵfac = function BhTabs_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTabs)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTabs,
      selectors: [["bh-tabs"]],
      inputs: {
        activeKey: "activeKey",
        ellipsisTextLimit: "ellipsisTextLimit",
        isBorder: "isBorder",
        isSmall: "isSmall",
        items: "items",
        menuEllipsis: "menuEllipsis",
        menuWidth: "menuWidth"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTabs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTabs = __decorate([ProxyCmp({
    inputs: ['activeKey', 'ellipsisTextLimit', 'isBorder', 'isSmall', 'items', 'menuEllipsis', 'menuWidth']
  })], BhTabs);
  return BhTabs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTabularList = /*#__PURE__*/(() => {
  let BhTabularList = class BhTabularList {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventSelected', 'bhEventChange', 'bhEventCtaClick', 'bhEventAppended', 'bhEventScroll']);
    }
    static ɵfac = function BhTabularList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTabularList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTabularList,
      selectors: [["bh-tabular-list"]],
      inputs: {
        clearFilter: "clearFilter",
        enableMicroInteraction: "enableMicroInteraction",
        header: "header",
        id: "id",
        isLoading: "isLoading",
        noDataAvailable: "noDataAvailable",
        option: "option",
        overridecss: "overridecss",
        payload: "payload",
        refresh: "refresh",
        schema: "schema",
        selectedItems: "selectedItems"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTabularList_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTabularList = __decorate([ProxyCmp({
    inputs: ['clearFilter', 'enableMicroInteraction', 'header', 'id', 'isLoading', 'noDataAvailable', 'option', 'overridecss', 'payload', 'refresh', 'schema', 'selectedItems']
  })], BhTabularList);
  return BhTabularList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTextArea = /*#__PURE__*/(() => {
  let BhTextArea = class BhTextArea {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['changed', 'bhEventInput', 'bhEventChange']);
    }
    static ɵfac = function BhTextArea_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTextArea)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTextArea,
      selectors: [["bh-text-area"]],
      inputs: {
        fluidHorz: "fluidHorz",
        fluidVert: "fluidVert",
        isDisabled: "isDisabled",
        isError: "isError",
        isReadOnly: "isReadOnly",
        isRequired: "isRequired",
        label: "label",
        maxChar: "maxChar",
        messageText: "messageText",
        messageType: "messageType",
        placeholder: "placeholder",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTextArea_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTextArea = __decorate([ProxyCmp({
    inputs: ['fluidHorz', 'fluidVert', 'isDisabled', 'isError', 'isReadOnly', 'isRequired', 'label', 'maxChar', 'messageText', 'messageType', 'placeholder', 'value']
  })], BhTextArea);
  return BhTextArea;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTextInput = /*#__PURE__*/(() => {
  let BhTextInput = class BhTextInput {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventInput', 'bhEventChange', 'bhEventBlur']);
    }
    static ɵfac = function BhTextInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTextInput)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTextInput,
      selectors: [["bh-text-input"]],
      inputs: {
        endIcon: "endIcon",
        isDisabled: "isDisabled",
        isError: "isError",
        isFluid: "isFluid",
        isReadOnly: "isReadOnly",
        isRequired: "isRequired",
        isRounded: "isRounded",
        isSmall: "isSmall",
        isSmallWidth: "isSmallWidth",
        label: "label",
        maxLength: "maxLength",
        message: "message",
        onFocus: "onFocus",
        pattern: "pattern",
        placeholder: "placeholder",
        startIcon: "startIcon",
        type: "type",
        unit: "unit",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTextInput_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTextInput = __decorate([ProxyCmp({
    inputs: ['endIcon', 'isDisabled', 'isError', 'isFluid', 'isReadOnly', 'isRequired', 'isRounded', 'isSmall', 'isSmallWidth', 'label', 'maxLength', 'message', 'onFocus', 'pattern', 'placeholder', 'startIcon', 'type', 'unit', 'value']
  })], BhTextInput);
  return BhTextInput;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTimePicker = /*#__PURE__*/(() => {
  let BhTimePicker = class BhTimePicker {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange', 'bhEventInput']);
    }
    static ɵfac = function BhTimePicker_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTimePicker)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTimePicker,
      selectors: [["bh-time-picker"]],
      inputs: {
        disableHelper: "disableHelper",
        errorMessage: "errorMessage",
        format: "format",
        id: "id",
        isDisabled: "isDisabled",
        isInvalid: "isInvalid",
        isReadOnly: "isReadOnly",
        isRequired: "isRequired",
        isSmall: "isSmall",
        label: "label",
        value: "value",
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTimePicker_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTimePicker = __decorate([ProxyCmp({
    inputs: ['disableHelper', 'errorMessage', 'format', 'id', 'isDisabled', 'isInvalid', 'isReadOnly', 'isRequired', 'isSmall', 'label', 'value', 'width']
  })], BhTimePicker);
  return BhTimePicker;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTimeZonePicker = /*#__PURE__*/(() => {
  let BhTimeZonePicker = class BhTimeZonePicker {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhTimeZonePicker_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTimeZonePicker)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTimeZonePicker,
      selectors: [["bh-time-zone-picker"]],
      inputs: {
        isDisabled: "isDisabled",
        isError: "isError",
        isFluid: "isFluid",
        isRequired: "isRequired",
        isSmall: "isSmall",
        label: "label",
        menuWidth: "menuWidth",
        message: "message",
        placeholder: "placeholder",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTimeZonePicker_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTimeZonePicker = __decorate([ProxyCmp({
    inputs: ['isDisabled', 'isError', 'isFluid', 'isRequired', 'isSmall', 'label', 'menuWidth', 'message', 'placeholder', 'value']
  })], BhTimeZonePicker);
  return BhTimeZonePicker;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTitleWrapper = /*#__PURE__*/(() => {
  let BhTitleWrapper = class BhTitleWrapper {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventCtaClick']);
    }
    static ɵfac = function BhTitleWrapper_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTitleWrapper)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTitleWrapper,
      selectors: [["bh-title-wrapper"]],
      inputs: {
        cta: "cta",
        header: "header",
        subtext: "subtext",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTitleWrapper_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTitleWrapper = __decorate([ProxyCmp({
    inputs: ['cta', 'header', 'subtext', 'type']
  })], BhTitleWrapper);
  return BhTitleWrapper;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhToggle = /*#__PURE__*/(() => {
  let BhToggle = class BhToggle {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventChange']);
    }
    static ɵfac = function BhToggle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhToggle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhToggle,
      selectors: [["bh-toggle"]],
      inputs: {
        isChecked: "isChecked",
        isDisabled: "isDisabled",
        isError: "isError",
        label: "label",
        name: "name",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhToggle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhToggle = __decorate([ProxyCmp({
    inputs: ['isChecked', 'isDisabled', 'isError', 'label', 'name', 'value']
  })], BhToggle);
  return BhToggle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTokenDemo = /*#__PURE__*/(() => {
  let BhTokenDemo = class BhTokenDemo {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function BhTokenDemo_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTokenDemo)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTokenDemo,
      selectors: [["bh-token-demo"]],
      inputs: {
        tokens: "tokens"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTokenDemo_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTokenDemo = __decorate([ProxyCmp({
    inputs: ['tokens']
  })], BhTokenDemo);
  return BhTokenDemo;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTooltip = /*#__PURE__*/(() => {
  let BhTooltip = class BhTooltip {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventOpen', 'bhEventClose']);
    }
    static ɵfac = function BhTooltip_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTooltip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTooltip,
      selectors: [["bh-tooltip"]],
      inputs: {
        hide: "hide",
        invisible: "invisible",
        isFromTabularlist: "isFromTabularlist",
        isInline: "isInline",
        isLegend: "isLegend",
        isTitle: "isTitle",
        ismessage: "ismessage",
        legendData: "legendData",
        message: "message",
        placement: "placement",
        tooltipLeftPadding: "tooltipLeftPadding",
        tooltipMessageFromTop: "tooltipMessageFromTop",
        tooltipTitle: "tooltipTitle"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTooltip_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTooltip = __decorate([ProxyCmp({
    inputs: ['hide', 'invisible', 'isFromTabularlist', 'isInline', 'isLegend', 'isTitle', 'ismessage', 'legendData', 'message', 'placement', 'tooltipLeftPadding', 'tooltipMessageFromTop', 'tooltipTitle']
  })], BhTooltip);
  return BhTooltip;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTree = /*#__PURE__*/(() => {
  let BhTree = class BhTree {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventSelected']);
    }
    static ɵfac = function BhTree_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTree)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTree,
      selectors: [["bh-tree"]],
      inputs: {
        id: "id",
        option: "option",
        payload: "payload"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTree_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTree = __decorate([ProxyCmp({
    inputs: ['id', 'option', 'payload']
  })], BhTree);
  return BhTree;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhTypeAhead = /*#__PURE__*/(() => {
  let BhTypeAhead = class BhTypeAhead {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['selected', 'bhEventOpen', 'bhEventClose', 'bhEventSelected']);
    }
    static ɵfac = function BhTypeAhead_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhTypeAhead)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhTypeAhead,
      selectors: [["bh-type-ahead"]],
      inputs: {
        data: "data",
        isDisabled: "isDisabled",
        isError: "isError",
        isFluid: "isFluid",
        isSmall: "isSmall",
        placeholder: "placeholder",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhTypeAhead_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhTypeAhead = __decorate([ProxyCmp({
    inputs: ['data', 'isDisabled', 'isError', 'isFluid', 'isSmall', 'placeholder', 'value']
  })], BhTypeAhead);
  return BhTypeAhead;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhUploader = /*#__PURE__*/(() => {
  let BhUploader = class BhUploader {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhUploadSucess', 'bhUploadStart', 'bhUploadError', 'bhUploadProgress', 'bhFileReject', 'bhFilesChanged', 'bhMaxFilesReachedChanged', 'bhUploadAbort', 'bhUploadBefore', 'bhUploadRequest', 'bhUploadResponse', 'bhUploadRetry']);
    }
    static ɵfac = function BhUploader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhUploader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhUploader,
      selectors: [["bh-uploader"]],
      inputs: {
        fileType: "fileType",
        headers: "headers",
        helpText: "helpText",
        id: "id",
        isDisabled: "isDisabled",
        isSmall: "isSmall",
        isTarget: "isTarget",
        label: "label",
        leftIcon: "leftIcon",
        maxFileSize: "maxFileSize",
        maxFiles: "maxFiles",
        method: "method",
        noAuto: "noAuto",
        target: "target",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhUploader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhUploader = __decorate([ProxyCmp({
    inputs: ['fileType', 'headers', 'helpText', 'id', 'isDisabled', 'isSmall', 'isTarget', 'label', 'leftIcon', 'maxFileSize', 'maxFiles', 'method', 'noAuto', 'target', 'type']
  })], BhUploader);
  return BhUploader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BhVerticalMenu = /*#__PURE__*/(() => {
  let BhVerticalMenu = class BhVerticalMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['bhEventSelected']);
    }
    static ɵfac = function BhVerticalMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BhVerticalMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BhVerticalMenu,
      selectors: [["bh-vertical-menu"]],
      inputs: {
        menuItems: "menuItems",
        selected: "selected"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BhVerticalMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  BhVerticalMenu = __decorate([ProxyCmp({
    inputs: ['menuItems', 'selected']
  })], BhVerticalMenu);
  return BhVerticalMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ValueAccessor = /*#__PURE__*/(() => {
  class ValueAccessor {
    el;
    onChange = () => {};
    onTouched = () => {};
    lastValue;
    constructor(el) {
      this.el = el;
    }
    writeValue(value) {
      this.el.nativeElement.value = this.lastValue = value == null ? '' : value;
    }
    handleChangeEvent(value) {
      if (value !== this.lastValue) {
        this.lastValue = value;
        this.onChange(value);
      }
    }
    _handleBlurEvent() {
      this.onTouched();
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.el.nativeElement.disabled = isDisabled;
    }
    static ɵfac = function ValueAccessor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ValueAccessor,
      hostBindings: function ValueAccessor_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focusout", function ValueAccessor_focusout_HostBindingHandler() {
            return ctx._handleBlurEvent();
          });
        }
      },
      standalone: false
    });
  }
  return ValueAccessor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BooleanValueAccessor = /*#__PURE__*/(() => {
  class BooleanValueAccessor extends ValueAccessor {
    constructor(el) {
      super(el);
    }
    writeValue(value) {
      this.el.nativeElement.checked = this.lastValue = value == null ? false : value;
    }
    static ɵfac = function BooleanValueAccessor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BooleanValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BooleanValueAccessor,
      selectors: [["bh-checkbox"], ["bh-radio-button"], ["bh-toggle"]],
      hostBindings: function BooleanValueAccessor_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("bhEventChange", function BooleanValueAccessor_bhEventChange_HostBindingHandler($event) {
            return ctx.handleChangeEvent($event.target.isChecked);
          });
        }
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: BooleanValueAccessor,
        multi: true
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return BooleanValueAccessor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NumericValueAccessor = /*#__PURE__*/(() => {
  class NumericValueAccessor extends ValueAccessor {
    constructor(el) {
      super(el);
    }
    registerOnChange(fn) {
      super.registerOnChange(value => {
        fn(value === '' ? null : parseFloat(value));
      });
    }
    static ɵfac = function NumericValueAccessor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NumericValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NumericValueAccessor,
      selectors: [["bh-slider"]],
      hostBindings: function NumericValueAccessor_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("bhEventChange", function NumericValueAccessor_bhEventChange_HostBindingHandler($event) {
            return ctx.handleChangeEvent($event.target.value);
          });
        }
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: NumericValueAccessor,
        multi: true
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return NumericValueAccessor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectValueAccessor = /*#__PURE__*/(() => {
  class SelectValueAccessor extends ValueAccessor {
    constructor(el) {
      super(el);
    }
    static ɵfac = function SelectValueAccessor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SelectValueAccessor,
      selectors: [["bh-dropdown"], ["bh-inline-dropdown"]],
      hostBindings: function SelectValueAccessor_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("bhEventChange", function SelectValueAccessor_bhEventChange_HostBindingHandler($event) {
            return ctx.handleChangeEvent($event.target.value);
          });
        }
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: SelectValueAccessor,
        multi: true
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return SelectValueAccessor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextValueAccessor = /*#__PURE__*/(() => {
  class TextValueAccessor extends ValueAccessor {
    constructor(el) {
      super(el);
    }
    static ɵfac = function TextValueAccessor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TextValueAccessor)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TextValueAccessor,
      selectors: [["bh-text-area"], ["bh-text-input"], ["bh-search"], ["bh-type-ahead"], ["bh-date-picker"], ["bh-date-range-picker"], ["bh-date-time-picker"], ["bh-time-picker"], ["bh-time-zone-picker"], ["bh-incrementer"]],
      hostBindings: function TextValueAccessor_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("bhEventChange", function TextValueAccessor_bhEventChange_HostBindingHandler($event) {
            return ctx.handleChangeEvent($event.target.value);
          });
        }
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: TextValueAccessor,
        multi: true
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return TextValueAccessor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
defineCustomElements(window);
const DECLARATIONS = [
// proxies
BhA, BhAccordion, BhActionBar, BhActionMenu, BhAlert, BhAlertItem, BhAppShell, BhAppShellMenu, BhAvatar, BhAvatarGroup, BhBadge, BhBarChart, BhBreadcrumbs, BhButton, BhButtonDropdown, BhButtonGroup, BhButtonTabs, BhCard, BhCheckbox, BhChip, BhChipGroup, BhContent, BhDataTable, BhDatePicker, BhDateTimePicker, BhDateRangePicker, BhDialog, BhDivider, BhDonutChart, BhDropdown, BhError, BhFooter, BhFormMessage, BhHeader, BhIcon, BhIllustration, BhIncrementer, BhInlineDropdown, BhKpi, BhLineChart, BhList, BhMenu, BhMenuItem, BhMobileMenu, BhModal, BhNavMenu, BhPagination, BhPanel, BhProgressBar, BhRadioButton, BhScatterChart, BhSearch, BhSelectionGroup, BhSettingsMenu, BhSlider, BhSpinner, BhStatusIndicator, BhStepper, BhSystemAlertItem, BhTabs, BhTabularList, BhTextArea, BhTextInput, BhTimePicker, BhTimeZonePicker, BhTitleWrapper, BhToggle, BhTokenDemo, BhTooltip, BhTree, BhTypeAhead, BhUploader, BhVerticalMenu,
// value accssessors
BooleanValueAccessor, NumericValueAccessor, SelectValueAccessor, TextValueAccessor];
let ComponentLibraryModule = /*#__PURE__*/(() => {
  class ComponentLibraryModule {
    static ɵfac = function ComponentLibraryModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ComponentLibraryModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ComponentLibraryModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return ComponentLibraryModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// DIRECTIVES

/**
 * Generated bundle index. Do not edit.
 */

export { BhA, BhAccordion, BhActionBar, BhActionMenu, BhAlert, BhAlertItem, BhAppShell, BhAppShellMenu, BhAvatar, BhAvatarGroup, BhBadge, BhBarChart, BhBreadcrumbs, BhButton, BhButtonDropdown, BhButtonGroup, BhButtonTabs, BhCard, BhCheckbox, BhChip, BhChipGroup, BhContent, BhDataTable, BhDatePicker, BhDateRangePicker, BhDateTimePicker, BhDialog, BhDivider, BhDonutChart, BhDropdown, BhError, BhFooter, BhFormMessage, BhHeader, BhIcon, BhIllustration, BhIncrementer, BhInlineDropdown, BhKpi, BhLineChart, BhList, BhMenu, BhMenuItem, BhMobileMenu, BhModal, BhNavMenu, BhPagination, BhPanel, BhProgressBar, BhRadioButton, BhScatterChart, BhSearch, BhSelectionGroup, BhSettingsMenu, BhSlider, BhSpinner, BhStatusIndicator, BhStepper, BhSystemAlertItem, BhTabs, BhTabularList, BhTextArea, BhTextInput, BhTimePicker, BhTimeZonePicker, BhTitleWrapper, BhToggle, BhTokenDemo, BhTooltip, BhTree, BhTypeAhead, BhUploader, BhVerticalMenu, BooleanValueAccessor, ComponentLibraryModule, NumericValueAccessor, SelectValueAccessor, TextValueAccessor };
